import styled from "@emotion/styled"

export const MyForYourVehicle = {
    block: styled.section`
        background-color: #ffffff;
        padding: 77px 0;
        width: 100%;

        .react-multi-carousel-list {
            overflow: visible;
        }
    `,
    wrapper: styled.div`
        max-width: 1480px;
        margin: 0 auto;
        padding: 0 20px;
    `
}